/** Event registration question labels — API values stay English; labelKeys map to i18n JSON. */

/** Values sent to the API unchanged; labelKey is for display only. */
export const EVENT_STAGE_OPTIONS = [
  { value: "Early Stage", labelKey: "events.stage.earlyStage" },
  { value: "Growth", labelKey: "events.stage.growth" },
  { value: "Established", labelKey: "events.stage.established" },
  { value: "Executive", labelKey: "events.stage.executive" },
] as const;

export const EVENT_OBJECTIVES_OPTIONS = [
  { value: "B2B Lead generation", labelKey: "events.objectives.b2bLeadGeneration" },
  { value: "Finding reliable B2B services", labelKey: "events.objectives.findingB2bServices" },
  {
    value: "Getting mentorship/advice from experienced business owners",
    labelKey: "events.objectives.mentorshipAdvice",
  },
  {
    value: "Supporting growing Muslim businesses",
    labelKey: "events.objectives.supportingMuslimBusinesses",
  },
  {
    value: "Finding potential investment opportunities",
    labelKey: "events.objectives.investmentOpportunities",
  },
  { value: "Meeting potential investors", labelKey: "events.objectives.meetingInvestors" },
  {
    value: "Meeting online connections in person",
    labelKey: "events.objectives.meetingOnlineConnections",
  },
  {
    value: "Learning more about SMBF / SMBF Services",
    labelKey: "events.objectives.learningSmbf",
  },
  { value: "General networking", labelKey: "events.objectives.generalNetworking" },
  {
    value: "Exploring business partnerships",
    labelKey: "events.objectives.exploringPartnerships",
  },
  { value: "Other", labelKey: "events.objectives.other" },
] as const;

export const EVENT_SECTOR_OPTIONS = [
  { value: "Accounting and Finance", labelKey: "events.sectors.accountingFinance" },
  { value: "Agriculture & Farming", labelKey: "events.sectors.agricultureFarming" },
  { value: "Arts & Creative", labelKey: "events.sectors.artsCreative" },
  { value: "Business Services", labelKey: "events.sectors.businessServices" },
  { value: "Construction & Property", labelKey: "events.sectors.constructionProperty" },
  { value: "Education & Training", labelKey: "events.sectors.educationTraining" },
  { value: "Energy & Environment", labelKey: "events.sectors.energyEnvironment" },
  {
    value: "Engineering & Manufacturing",
    labelKey: "events.sectors.engineeringManufacturing",
  },
  { value: "Food & Beverage", labelKey: "events.sectors.foodBeverage" },
  {
    value: "Government & Public Services",
    labelKey: "events.sectors.governmentPublicServices",
  },
  { value: "Healthcare & Medical", labelKey: "events.sectors.healthcareMedical" },
  { value: "Hospitality & Tourism", labelKey: "events.sectors.hospitalityTourism" },
  { value: "HR & Recruitment", labelKey: "events.sectors.hrRecruitment" },
  { value: "Insurance", labelKey: "events.sectors.insurance" },
  { value: "Legal & Compliance", labelKey: "events.sectors.legalCompliance" },
  {
    value: "Marketing, Advertising & Digital",
    labelKey: "events.sectors.marketingAdvertisingDigital",
  },
  {
    value: "Sports, Media & Entertainment",
    labelKey: "events.sectors.sportsMediaEntertainment",
  },
  { value: "Retail & E-Commerce", labelKey: "events.sectors.retailEcommerce" },
  { value: "Sales & Customer Service", labelKey: "events.sectors.salesCustomerService" },
  { value: "Science & Research", labelKey: "events.sectors.scienceResearch" },
  { value: "Technology & IT", labelKey: "events.sectors.technologyIt" },
  { value: "Telecommunication", labelKey: "events.sectors.telecommunication" },
  { value: "Third Sector", labelKey: "events.sectors.thirdSector" },
  { value: "Transport & Logistics", labelKey: "events.sectors.transportLogistics" },
  { value: "Other", labelKey: "events.sectors.other" },
] as const;

export const EVENT_OTHER_SECTOR_VALUE = "Other";
